module.exports = __webpack_public_path__ + "img/0001.1be300cf.png";